import React from 'react';

import { components } from 'react-select';

import { Caret } from './styles';

const DropdownIndicator =
    (highlighted = false) =>
    (props) =>
        (
            <components.DropdownIndicator {...props} className="dropdownIndicator">
                <Caret $highlighted={highlighted}></Caret>
            </components.DropdownIndicator>
        );

export default DropdownIndicator;
